'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _components = require('components');

var _reduxForm = require('redux-form');

var _zendesk = require('../../redux/modules/zendesk');

var _EnterpriseProgramFormValidation = require('../../utils/EnterpriseProgramFormValidation');

var _EnterpriseProgramFormValidation2 = _interopRequireDefault(_EnterpriseProgramFormValidation);

var _EnterpriseSubscriptionPopup = require('@quixeltools/quixel-ui-library/dist/components/megascans/popups/EnterpriseSubscriptionPopup');

var _EnterpriseSubscriptionPopup2 = _interopRequireDefault(_EnterpriseSubscriptionPopup);

var _ThanksPopup = require('@quixeltools/quixel-ui-library/dist/components/megascans/popups/ThanksPopup');

var _ThanksPopup2 = _interopRequireDefault(_ThanksPopup);

var _utils = require('utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EnterpriseSubscriptionContainer = (_dec = (0, _reduxForm.reduxForm)({
  form: 'EnterpriseProgram',
  fields: ['name', 'email', 'company', 'phone', 'position', 'companyUrl', 'comments', 'industry', 'country'],
  validate: _EnterpriseProgramFormValidation2.default
}), _dec2 = (0, _reactRedux.connect)(null, { createLeadTicket: _zendesk.createLeadTicket, cacheTicket: _zendesk.cacheTicket, sendCacheTicket: _zendesk.sendCacheTicket }), _dec(_class = _dec2(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(EnterpriseSubscriptionContainer, _React$Component);

  function EnterpriseSubscriptionContainer(props) {
    (0, _classCallCheck3.default)(this, EnterpriseSubscriptionContainer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (EnterpriseSubscriptionContainer.__proto__ || (0, _getPrototypeOf2.default)(EnterpriseSubscriptionContainer)).call(this, props));

    _this.state = {
      message: null,
      error: null
    };

    _this.onSubmitClick = _this.onSubmitClick.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(EnterpriseSubscriptionContainer, [{
    key: 'onSubmitClick',
    value: function onSubmitClick(values) {
      this.setState({
        message: null,
        error: null
      });

      var name = values.name,
          email = values.email,
          company = values.company,
          phone = values.phone,
          position = values.position,
          companyUrl = values.companyUrl,
          comments = values.comments,
          industry = values.industry,
          country = values.country;


      var tag = this.props.tag || 'regular';

      //ThanksPopup
      this.props.createLeadTicket({
        title: position,
        last_name: name,
        organization_name: company,
        description: comments,
        industry: industry,
        phone: phone,
        source_id: 949849,
        website: companyUrl,
        email: email,
        tags: [tag, 'inbound-lead'],
        address: {
          country: country
        },
        custom_fields: {
          designation: 'Designation: ' + position
        }
      });

      this.context.dialogs.custom(_react2.default.createElement(
        _components.AppSideEffects,
        null,
        _react2.default.createElement(_ThanksPopup2.default, {
          icon: '/quixel_logo.png',
          closePopup: this.props.onCloseYes,
          title: 'Thanks!',
          description: 'We\u2019ve got your info, and will get back to you soon.',
          message: '<p >Thanks for asking about Quixel for Enterprise. </p> <br></br> <p>Someone from our team will get in touch with you very soon.</p>'
        })
      ));
    }
  }, {
    key: 'render',
    value: function render() {

      var countryList = [];
      (0, _utils.getCountryList)().important.map(function (obj) {
        var temp = {};
        temp.value = obj.name;
        temp.name = obj.name;
        countryList.push(temp);
      });
      (0, _utils.getCountryList)().rest.map(function (obj) {
        var temp = {};
        temp.value = obj.name;
        temp.name = obj.name;
        countryList.push(temp);
      });

      var _props = this.props,
          _props$fields = _props.fields,
          nameInputProps = _props$fields.name,
          emailInputProps = _props$fields.email,
          companyProps = _props$fields.company,
          phoneProps = _props$fields.phone,
          messageProps = _props$fields.comments,
          positionProps = _props$fields.position,
          companyUrlProps = _props$fields.companyUrl,
          industryProps = _props$fields.industry,
          countryProps = _props$fields.country,
          handleSubmit = _props.handleSubmit,
          submitting = _props.submitting,
          title = _props.title,
          description = _props.description,
          tag = _props.tag;

      return _react2.default.createElement(_EnterpriseSubscriptionPopup2.default, {

        icon: '/quixel_logo.png',
        title: title,
        description: description,

        nameInputProps: nameInputProps,
        emailInputProps: emailInputProps,
        companyProps: companyProps,
        phoneProps: phoneProps,
        positionProps: positionProps,
        companyUrlProps: companyUrlProps,
        countryProps: countryProps,
        industryProps: industryProps,
        messageProps: messageProps,
        country: countryList,

        error: this.state.error,
        message: this.state.message,
        submitting: submitting,
        onSubmit: handleSubmit(this.onSubmitClick)

      });
    }
  }]);
  return EnterpriseSubscriptionContainer;
}(_react2.default.Component), _class2.contextTypes = {
  router: _react2.default.PropTypes.object,
  dialogs: _react2.default.PropTypes.object
}, _temp)) || _class) || _class);
exports.default = EnterpriseSubscriptionContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/EnterpriseSubscriptionContainer/EnterpriseSubscriptionContainer.jsx
// module id = 2815
// module chunks = 0